import React from 'react';
import { GalleryItem } from './gallery-item';

const MAX_ITEM = 7

const GalleryItems = ({data, height, handlePopup, itemWidth = "w-1/3 lg:w-1/4"}) => {
  const isMax = data.length > MAX_ITEM

  return <>
    <div className="flex flex-wrap -mx-1 lg:-mx-4">
      {
        data.map((image, index) => index < MAX_ITEM && (
          <div className={`${itemWidth} px-1 lg:px-4 mb-2 lg:mb-8`} key={index}>
            <GalleryItem height={height} onClick={() => handlePopup(index)} src={image}/>
          </div>
        ))
      }
      {
        isMax &&
        <div className={`${itemWidth} px-1 lg:px-4 mb-2 lg:mb-8`}>
          <div className="relative" onClick={() => handlePopup(MAX_ITEM)}>
            <div className="rounded cursor-pointer absolute w-full h-full flex items-center justify-center" style={{background: 'rgba(0, 0, 0, 0.75)'}}>
              <p className="text-white underline text-sm">+{data.length - MAX_ITEM} More</p>
            </div>
            <GalleryItem height={height} src={data[MAX_ITEM]}/>
          </div>
        </div>
      }
    </div>
  </>
}

export { GalleryItems }
